import { render, staticRenderFns } from "./feeder.vue?vue&type=template&id=11a06656&"
import script from "./feeder.vue?vue&type=script&lang=js&"
export * from "./feeder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports